import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdatePartnerParams } from 'domain/models/params';
import { UpdatePartnerUseCaseInterface } from 'domain/usecases';

export class RemoteUpdatePartner implements UpdatePartnerUseCaseInterface {
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient,
  ) {}

  async execute(params: UpdatePartnerParams): Promise<UpdatePartnerUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: `${this.baseUrl}/${id}`,
      method: 'patch',
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
